import { Box } from '@mui/material';
import CifaAPI from 'api/cifa/cifa.api';
import { Header } from 'components/home';
import { StepperHorizontal } from 'components/shared/stepper_horizontal';
import { TopNavBar } from 'components/top_nav_bar';
import { MenuProvider } from 'contexts/menu/menu_context';
import { useFormik } from 'formik';
import React, { useState } from 'react';
import useCifaStore from 'stores/cifa/cifa.store';
import { complianceTermValidationSchema } from './complianceTerm.validation';
import Step1 from './Step1';
import Step2 from './Step2';
import { useLocation } from 'react-router-dom';

export interface InstitutionI {
  id: number;
  name: string;
}


const ComplianceTerm: React.FC = () => {
  const location = useLocation();
  // Extrai o ano da rota, ex: /service_management/cifa-2027 => 2027
  const match = location.pathname.match(/cifa-(\d{4})/);
  const anoReferencia = match ? Number(match[1]) : 2026;

  const steps = ['Cumprimento do Termo', 'Confirmação dos Dados'];
  const [activeStep, setActiveStep] = useState<number>(0);
  const { cifa } = useCifaStore();
  const [submittedOnce, setSubmittedOnce] = useState(false);

  const handleSave = async () => {
    const response = await CifaAPI.updateCumprimentoDoTermoEscolar(cifa.uuid!, formik.values);
    console.log(response);
  }

  const formik = useFormik({
    initialValues: {
      termo_escolar_pmaf_elaborado: cifa.termo_escolar_pmaf_elaborado,
      termo_escolar_pmaf_validado_seaf_mt: cifa.termo_escolar_pmaf_validado_seaf_mt,
      termo_escolar_ato_normativo_publicado: cifa.termo_escolar_ato_normativo_publicado,
      termo_escolar_ato_normativo_uuid: cifa.termo_escolar_ato_normativo_uuid,
      termo_escolar_cmdrs_constituido: cifa.termo_escolar_cmdrs_constituido,
      termo_escolar_atas_reunioes_uuid: cifa.termo_escolar_atas_reunioes_uuid
    },
    validationSchema: complianceTermValidationSchema,
    onSubmit: async () => {
      if (activeStep === 0) {
        setActiveStep((prevStep) => prevStep + 1);
        return;
      }

      await handleSave();
    },
    validateOnChange: submittedOnce,
    validateOnBlur: submittedOnce,
  })



  const handleNext = () => {
    setSubmittedOnce(true);
    formik.handleSubmit();
  };

  const handleBack = () => setActiveStep((prevStep) => prevStep - 1);

  return (
    <MenuProvider>
      <TopNavBar />
      <Header title={`CIFA - Cadastrar Município - ${anoReferencia}`} showBackButton={true} />
      <Box width='97%' display='flex' flexDirection='column' justifyContent='center' alignItems='center' margin='2rem'>
        <StepperHorizontal activeStep={activeStep} steps={steps} maxWidth='1152px' />
        {activeStep === 0 && (
          <Step1 formik={formik} onNext={handleNext} />
        )}
        {activeStep === 1 && <Step2 formik={formik} onBack={handleBack} />}
      </Box>
    </MenuProvider>
  );
};

export default ComplianceTerm;
